export default (ra) => ({
  async seen (data) {
    await ra.track('Tariffs Modal Seen', data)
  },

  async closed (data) {
    await ra.track('Tariffs Modal Closed', data)
  },

  async submittedEmail (data) {
    await ra.track('Tarrifs Modal Email Submitted', data)
  }
})
